module.exports = __webpack_public_path__ + "img/ch.b64602aa.svg";